import { type PropsWithChildren } from 'react';
import { ShadowEmbedRoot } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';

export function EmbedRoot({ children }: PropsWithChildren) {
  const {
    customCSS,
    theme: {
      themeSettings: { font }
    }
  } = useSettings();

  return (
    <ShadowEmbedRoot customCSS={customCSS} font={font}>
      {children}
    </ShadowEmbedRoot>
  );
}
